import React from 'react'

import Section from 'components/smartSearch/SidebarSection/SidebarSection'
import Title from 'components/smartSearch/SidebarTitle/SidebarTitle'

import Link from '../Link/Link'


const SEOGenderLinks = ({ pathname, gender }) => {
  let slug

  if (pathname === '/perfumes') {
    slug = 'Perfumes'
  }
  else if (pathname === '/colognes') {
    slug = 'Colognes'
  }
  else if (pathname === '/fragrance') {
    slug = 'Fragrance'
  }
  else {
    slug = gender === 'female' ? 'Perfumes' : 'Colognes'
  }

  return (
    <Section>
      <Title title="Gender" />
      <Link to={`/${slug.toLowerCase()}-for-women`}>{slug} for Women</Link>
      <Link to={`/${slug.toLowerCase()}-for-men`}>{slug} for Men</Link>
    </Section>
  )
}

export default SEOGenderLinks
